export default "__VITE_ASSET__BQ09xp2R__"